/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyList } from './CompanyList';
import {
    CompanyListFromJSON,
    CompanyListFromJSONTyped,
    CompanyListToJSON,
    CompanyListToJSONTyped,
} from './CompanyList';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseCompany
 */
export interface ResponseCompany {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseCompany
     */
    result: ResponseResult;
    /**
     * 
     * @type {CompanyList}
     * @memberof ResponseCompany
     */
    data: CompanyList;
}

/**
 * Check if a given object implements the ResponseCompany interface.
 */
export function instanceOfResponseCompany(value: object): value is ResponseCompany {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseCompanyFromJSON(json: any): ResponseCompany {
    return ResponseCompanyFromJSONTyped(json, false);
}

export function ResponseCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': CompanyListFromJSON(json['data']),
    };
}

export function ResponseCompanyToJSON(json: any): ResponseCompany {
    return ResponseCompanyToJSONTyped(json, false);
}

export function ResponseCompanyToJSONTyped(value?: ResponseCompany | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': CompanyListToJSON(value['data']),
    };
}

